"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePositionPnlByLatestPrice = exports.useCurrencyRiskState = exports.useAccountRiskState = exports.isLiquidatingMode = exports.useCustomBalance = exports.useFPBalanceInfo = exports.getCustomAssetsObservable = exports.useCustomAssets = exports.usePositionsList = exports.usePositionsWithFilter = exports.usePositionWithId = exports.refreshAccountDetail = exports.processPositionWithPrice = exports.calcPositionUPnl = exports.getPositionBalance = exports.DefaultAsset = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const interface_1 = require("../../../interface");
const SymbolComponent_1 = require("../../FuturesConfig/SymbolComponent");
const CalculateUtils_1 = require("../../Trade/FutureTrade/CalculateUtils");
const CustomAssetContext_1 = require("./../../../context/CustomAssetContext");
const precision_1 = require("./../../../component/FuturesConfig/precision");
const rx_1 = require("./../../../component/CustomOrders/CustomTPSLProvider/rx");
const const_1 = require("./../../../component/const");
exports.DefaultAsset = {
    riskState: interface_1.TraderAccountRiskState.TRADING,
    positions: [],
    balances: [],
    positionMap: new Map(),
    positionIdMap: new Map(),
    balanceMap: new Map(),
    positionMode: interface_1.OrderPositionMode.BUYSELL,
    requestError: "loading",
};
let positionModeCacheWhenError = interface_1.OrderPositionMode.BUYSELL;
const FetchAssets = (params) => {
    const fetchData = (0, FutureAPI_1.queryFutureBalance)(params).pipe((0, operators_1.tap)((res) => {
        if (res.position_mode) {
            // 更新内存中的position mode，接口请求失败的时候将使用该值
            positionModeCacheWhenError = res.position_mode;
        }
    }), (0, operators_1.catchError)((err) => {
        if (err.code === "ECONNABORTED") {
            return rxjs_1.NEVER;
        }
        else {
            const info = {
                risk_state: interface_1.TraderAccountRiskState.TRADING,
                balances: [],
                positions: [],
                error: err,
                position_mode: positionModeCacheWhenError,
                quote_risks: [],
            };
            return (0, rxjs_1.of)(info);
        }
    }));
    return fetchData;
};
function getPositionBalance(position, coin = "USDT") {
    return (position.balances || []).find((it) => it.coin === coin);
}
exports.getPositionBalance = getPositionBalance;
/**获取逐仓的保证金率 */
function getIsolatePositionMarginRate(maint_margin, balance) {
    if (!balance) {
        return "";
    }
    const { assets, debts, unrealized_pnl } = balance;
    const maintMarginD = new trade_utils_lib_1.SafeDecimal(maint_margin);
    const availableD = new trade_utils_lib_1.SafeDecimal(assets).add(new trade_utils_lib_1.SafeDecimal(debts)).add(new trade_utils_lib_1.SafeDecimal(unrealized_pnl));
    return availableD.eq(0) ? "" : maintMarginD.div(availableD).toString();
}
/**
 * 计算仓位的未实现盈亏
 *
 * @param price 外部传入的最新价格,或者仓位上的标记价格，如果latestPrice存在值，则使用latestPrice进行计算
 */
function calcPositionUPnl(position, basePrice = "") {
    const { qty_long, qty_short = "", amount_long = "", amount_short = "", amount_settle = "", leverage, position_side } = position;
    // 如果传入的基准价格有问题，取仓位中返回的标记价格
    const priceD = new trade_utils_lib_1.SafeDecimal(basePrice ? basePrice : position.mark_price);
    const positionQty = new trade_utils_lib_1.SafeDecimal(qty_long).add(qty_short);
    // 先简单的取绝对值
    const avgPrice = new trade_utils_lib_1.SafeDecimal(amount_long).add(amount_short).add(amount_settle).div(positionQty).abs();
    const diff = new trade_utils_lib_1.SafeDecimal(priceD).sub(avgPrice);
    const profit = positionQty.mul(diff);
    const positionSide = position_side === interface_1.FuturePositionSide.LONG ? 1 : -1;
    const profitRate = diff.div(avgPrice).mul(new trade_utils_lib_1.SafeDecimal(leverage)).mul(positionSide);
    return {
        unrealizedPnl: profit.toFixed(),
        unrealizedPnlRate: profitRate.toDecimalPlaces(4, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toString(),
    };
}
exports.calcPositionUPnl = calcPositionUPnl;
/**
 * 根据传入的价格，对仓位的相关参数重新计算
 *
 * @param price 外部传入的最新价格,或者仓位上的标记价格，如果latestPrice存在值，则使用latestPrice进行计算
 */
function processPositionWithPrice(position, basePrice = "") {
    const { positionQuantity } = position;
    const { unrealizedPnl, unrealizedPnlRate } = calcPositionUPnl(position, basePrice);
    const priceD = new trade_utils_lib_1.SafeDecimal(basePrice ? basePrice : position.mark_price);
    const value = new trade_utils_lib_1.SafeDecimal(positionQuantity).abs().mul(priceD);
    return Object.assign(Object.assign({}, position), { positionValue: value.toFixed(), unrealizedPnl: unrealizedPnl, unrealizedPnlRate: unrealizedPnlRate });
}
exports.processPositionWithPrice = processPositionWithPrice;
function processPosition(value, marginRate, symbolInfo) {
    const { qty_long, qty_short = "", mark_price = "", amount_long = "", amount_short = "", amount_settle = "", leverage = 1, isolated_mode, maint_margin, } = value;
    const isCross = CalculateUtils_1.CalculateUtils.isOrderCrossMode(isolated_mode);
    const currency = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quote;
    const pBalance = isCross ? undefined : getPositionBalance(value, currency);
    const qtyLongD = new trade_utils_lib_1.SafeDecimal(qty_long);
    const qtyShortD = new trade_utils_lib_1.SafeDecimal(qty_short);
    const amtLongD = new trade_utils_lib_1.SafeDecimal(amount_long);
    const amtShortD = new trade_utils_lib_1.SafeDecimal(amount_short);
    const amtSettleD = new trade_utils_lib_1.SafeDecimal(amount_settle);
    const realMarginRate = isCross ? marginRate !== null && marginRate !== void 0 ? marginRate : "" : getIsolatePositionMarginRate(maint_margin, pBalance);
    const markPrice = new trade_utils_lib_1.SafeDecimal(mark_price);
    const positionQty = qtyLongD.add(qtyShortD);
    const positionQtyABS = positionQty.abs();
    // 先简单的取绝对值
    const avgPrice = amtLongD.add(amtShortD).add(amtSettleD).div(positionQty).abs();
    const positionValue = positionQtyABS.mul(markPrice);
    // FIX: 占用保证金不再直接使用后端返回的值，而是通过前端计算，计算公式为 占用保证金 = abs（持仓量*标记价格/杠杆倍数）
    // const initialMargin = new SafeDecimal(initial_margin);
    const initialMargin = isCross ? positionValue.div(leverage) : new trade_utils_lib_1.SafeDecimal(pBalance === null || pBalance === void 0 ? void 0 : pBalance.assets).add(new trade_utils_lib_1.SafeDecimal(pBalance === null || pBalance === void 0 ? void 0 : pBalance.debts));
    const amountSettle = new trade_utils_lib_1.SafeDecimal(amount_settle).mul(-1);
    const calcuParams = {
        positionValue: positionValue.toString(),
        realizedPnl: amountSettle.toString(),
        avgPrice: avgPrice.toString(),
        positionQuantity: positionQty.toString(),
        initialMargin: initialMargin.toString(),
        marginRate: realMarginRate,
        currency,
        // 注意USDT相关的写死成2，非USDT则返回当前symbol的quote精度
        currencyPrecision: (0, precision_1.getFuturesCoinPrecision)(currency),
    };
    const calcuPnl = calcPositionUPnl(value);
    return Object.assign(value, calcuParams, calcuPnl);
}
function processBalance(balance) {
    const free = new trade_utils_lib_1.SafeDecimal(balance.free);
    const debts = new trade_utils_lib_1.SafeDecimal(balance.debts);
    const totalPNL = new trade_utils_lib_1.SafeDecimal(balance.unrealized_pnl);
    const marginUsed = new trade_utils_lib_1.SafeDecimal(balance.total_initial_margin);
    // available实际值 =free + debts + 总浮动盈亏 - 总占用保证金
    const avaMargin = free.add(debts).add(totalPNL).sub(marginUsed);
    return Object.assign(balance, { availableMargin: avaMargin.toString() });
}
/**
 * 获取trader账户多币种的保证金率，仅针对全仓的币对
 * @description 遍历trader账户的所有持仓并对占用保证金`maint_margin`进行求和,除以USDT币种的总权益`free+debts+unrealized_pnl`,计算当前账户的保证金率
 * @description 计算公式`sum(maint_margin)/(free+debts+unrealized_pnl)`
 * > 注意：当前持仓中的每个仓位展示的保证金率同一个值
 * */
const SumMarginMap = new Map();
const RateMap = new Map();
const MarginRateList = [];
function getPositionMarginRate(supportCoins, balanceMap, positions) {
    MarginRateList.length = 0;
    RateMap.clear();
    SumMarginMap.clear();
    if (!positions) {
        return [RateMap, MarginRateList];
    }
    // 遍历仓位，按照不同的quote进行分组，获取到不同币种下的占用保证金总数
    // 需要注意的是，需要过滤掉非全仓仓位以及虚拟仓位
    positions.forEach((it) => {
        if (CalculateUtils_1.CalculateUtils.isOrderCrossMode(it.isolated_mode) && !CalculateUtils_1.CalculateUtils.isVirtualSymbol(it.symbol)) {
            const symbolInfo = SymbolComponent_1.SymbolPerpetualUSDTComponent.getExchangeSymbol(it.symbol);
            if (!symbolInfo) {
                return;
            }
            const decimal = SumMarginMap.get(symbolInfo.quote);
            if (!decimal) {
                SumMarginMap.set(symbolInfo.quote, new trade_utils_lib_1.SafeDecimal(it.maint_margin));
            }
            else {
                SumMarginMap.set(symbolInfo.quote, decimal.add(it.maint_margin));
            }
        }
    });
    // 需要注意此处用的symbol的quote，而不是symbol的quoteDisplay
    supportCoins.forEach((coin) => {
        const balance = balanceMap.get(coin);
        if (!balance) {
            return;
        }
        const sumD = SumMarginMap.get(coin) || new trade_utils_lib_1.SafeDecimal(0);
        const { free, debts, unrealized_pnl } = balance;
        const available = new trade_utils_lib_1.SafeDecimal(free).add(debts).add(unrealized_pnl);
        if (available.gt(0)) {
            const marginRate = sumD.div(available).toString();
            RateMap.set(coin, marginRate);
            MarginRateList.push({ quote: coin, totalMargin: sumD.toString(), marginRate });
        }
    });
    // 按照字典序进行排序
    MarginRateList.sort((a, b) => a.quote.localeCompare(b.quote));
    return [RateMap, MarginRateList.slice()];
}
const createPublish = (params) => {
    const pBalanceMap = new Map();
    const pBalances = [];
    const supportCoins = [];
    // 非虚拟仓位
    const ps = [];
    // 虚拟仓位
    const vps = [];
    const pMap = new Map();
    const pIdMap = new Map();
    const quoteRisks = [];
    const quoteRiskMap = new Map();
    return (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000, rxjs_1.asapScheduler), params.subject).pipe((0, operators_1.debounceTime)(200), (0, operators_1.switchMap)(() => {
        return FetchAssets(params).pipe((0, operators_1.tap)((res) => {
            // 仓位信息已经发生变跟，发送事件刷新仓位关联的止盈止损
            const ids = (res.positions || []).map((p) => p.position_id);
            (0, rx_1.dispatchPositionTpSlEvent)({
                event: "update",
                ids,
            });
        }), (0, operators_1.map)((res) => {
            var _a, _b, _c, _d, _e;
            pBalanceMap.clear();
            supportCoins.length = 0;
            (_a = res === null || res === void 0 ? void 0 : res.balances) === null || _a === void 0 ? void 0 : _a.forEach((balance, index) => {
                if (balance.coin !== CalculateUtils_1.VIRTUAL_CURRENCY) {
                    supportCoins.push(balance.coin);
                }
                const newB = processBalance(balance);
                pBalances[index] = newB;
                pBalanceMap.set(balance.coin, newB);
            });
            pBalances.length = (_c = (_b = res.balances) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
            const [marginRateMap, marginRateList] = getPositionMarginRate(supportCoins, pBalanceMap, res === null || res === void 0 ? void 0 : res.positions);
            ps.length = 0;
            vps.length = 0;
            pMap.clear();
            pIdMap.clear();
            (_d = res === null || res === void 0 ? void 0 : res.positions) === null || _d === void 0 ? void 0 : _d.forEach((e) => {
                var _a;
                const symbolInfo = SymbolComponent_1.SymbolPerpetualUSDTComponent.getExchangeSymbol(e.symbol);
                const pItem = processPosition(e, marginRateMap.get((symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quote) || "") || "", symbolInfo);
                if (CalculateUtils_1.CalculateUtils.isVirtualSymbol(pItem.symbol)) {
                    vps.push(pItem);
                }
                else {
                    ps.push(pItem);
                }
                pIdMap.set(pItem.position_id, pItem);
                if (pMap.has(e.symbol)) {
                    (_a = pMap.get(e.symbol)) === null || _a === void 0 ? void 0 : _a.push(pItem);
                }
                else {
                    pMap.set(e.symbol, [pItem]);
                }
            });
            quoteRiskMap.clear();
            (res.quote_risks || []).forEach((state, index) => {
                const newState = Object.assign(Object.assign({}, state), { isLiquidating: isLiquidatingMode(state.risk_state) });
                quoteRisks[index] = newState;
                quoteRiskMap.set(state.quote, newState);
            });
            quoteRisks.length = (_e = res.quote_risks.length) !== null && _e !== void 0 ? _e : 0;
            const info = {
                riskState: res === null || res === void 0 ? void 0 : res.risk_state,
                positions: ps.slice(),
                positionMap: new Map(pMap),
                positionIdMap: new Map(pIdMap),
                balances: pBalances.slice(),
                balanceMap: new Map(pBalanceMap),
                positionMode: res === null || res === void 0 ? void 0 : res.position_mode,
                requestError: res.error,
                marginRateList: marginRateList.slice(),
                virtualPositions: vps.slice(),
                quoteRisks: quoteRisks.slice(),
                quoteRiskMap: new Map(quoteRiskMap),
                hasPositions: ps.length > 0 || vps.length > 0,
            };
            return info;
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)(exports.DefaultAsset);
        }));
    }), (0, operators_1.publishBehavior)(exports.DefaultAsset), (0, operators_1.refCount)());
};
const futuresTriggerSubject = new rxjs_1.Subject();
const manualAccountPublish$ = createPublish({
    accountType: trade_utils_lib_1.AccountTradeType.trader,
    subject: futuresTriggerSubject,
});
/** 主动刷新assets */
const refreshAccountDetail = () => {
    futuresTriggerSubject.next(new Date().getTime());
};
exports.refreshAccountDetail = refreshAccountDetail;
/** 注册单个币对的持仓 */
const usePositionWithId = (positionId, active = true) => {
    const asset = (0, exports.useCustomAssets)(const_1.FutureAccountType, active);
    return (0, react_1.useMemo)(() => {
        return asset.positionIdMap.get(positionId);
    }, [asset.positionIdMap, positionId]);
};
exports.usePositionWithId = usePositionWithId;
/** 注册持仓列表  筛选逻辑 totalCount使用初始持仓总数 */
const usePositionsWithFilter = (curSymbol = "", active = true, filterFn, withVirtual = true) => {
    const positionData = (0, exports.usePositionsList)(curSymbol, active, withVirtual);
    const newPositionData = (0, react_1.useMemo)(() => {
        if (filterFn) {
            positionData.positions = positionData.positions.filter(filterFn);
        }
        return positionData;
    }, [filterFn, positionData]);
    return newPositionData;
};
exports.usePositionsWithFilter = usePositionsWithFilter;
/**
 * 注册持仓列表 根据当前币对进行排序 没有当前币种传空串
 * @param curSymbol 当前币对
 * @param active 是否激活
 * @param withVirtual 是否包含虚拟币种仓位
 */
const filterData = [];
const curSymbolItem = [];
const BTCItem = [];
const ETHItem = [];
const virtualList = [];
const usePositionsList = (curSymbol = "", active = true, withVirtual = true) => {
    const asset = (0, exports.useCustomAssets)(const_1.FutureAccountType, active);
    return (0, react_1.useMemo)(() => {
        filterData.length = 0;
        curSymbolItem.length = 0;
        BTCItem.length = 0;
        ETHItem.length = 0;
        virtualList.length = 0;
        // 进行一次排序 当前币对在最上边, BTC ETH其次,
        const allPositions = withVirtual ? asset.positions.concat(...(asset.virtualPositions || [])) : asset.positions;
        allPositions.forEach((e) => {
            if (e.symbol === curSymbol) {
                curSymbolItem.push(e);
                return;
            }
            if (CalculateUtils_1.CalculateUtils.isVirtualSymbol(e.symbol)) {
                virtualList.push(e);
                return;
            }
            if (e.symbol.startsWith("BTC.")) {
                BTCItem.push(e);
                return;
            }
            if (e.symbol.startsWith("ETH.")) {
                ETHItem.push(e);
                return;
            }
            filterData.push(e);
        });
        // 按照更新时间排序
        filterData.sort((a, b) => { var _a, _b; return Number((_a = b.updated_time) !== null && _a !== void 0 ? _a : 0) - Number((_b = a.updated_time) !== null && _b !== void 0 ? _b : 0); });
        // 添加虚拟仓位，虚拟仓位需要放到最末尾
        if (virtualList.length) {
            virtualList.sort((a, b) => a.symbol.localeCompare(b.symbol));
            filterData.push(...virtualList);
        }
        if (ETHItem.length) {
            filterData.splice(0, 0, ...ETHItem);
        }
        if (BTCItem.length) {
            filterData.splice(0, 0, ...BTCItem);
        }
        if (curSymbolItem.length) {
            filterData.splice(0, 0, ...curSymbolItem);
        }
        const data = {
            positions: filterData.slice(),
            positionMap: asset.positionMap,
            error: asset.requestError,
            totalCount: asset.positions.length,
        };
        return data;
    }, [asset.positionMap, asset.positions, asset.requestError, asset.virtualPositions, curSymbol, withVirtual]);
};
exports.usePositionsList = usePositionsList;
/** 注册资产细节 */
const useCustomAssets = (accountType, active = true) => {
    var _a;
    const [data, setData] = (0, react_1.useState)(exports.DefaultAsset);
    const asset = (_a = (0, CustomAssetContext_1.useCustomAssetContext)()) === null || _a === void 0 ? void 0 : _a.asset;
    const hasContextAsset = !!asset;
    (0, react_1.useEffect)(() => {
        if (!active || hasContextAsset) {
            return;
        }
        // const ob$ = accountType === AccountTradeType.bot ? botAccountPublish$ : manualAccountPublish$;
        const sub = manualAccountPublish$.subscribe({
            next: (res) => {
                setData(res);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [active, accountType, hasContextAsset]);
    (0, react_1.useEffect)(() => {
        const sub = (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .registerUserId()
            .subscribe({
            next: (userId) => {
                if (!userId) {
                    setData(exports.DefaultAsset);
                }
            },
            error: () => { },
        });
        return () => sub.unsubscribe();
    }, []);
    return asset !== null && asset !== void 0 ? asset : data;
};
exports.useCustomAssets = useCustomAssets;
const getCustomAssetsObservable = () => {
    return manualAccountPublish$;
};
exports.getCustomAssetsObservable = getCustomAssetsObservable;
/** 手动下单需要的balance和position信息 */
const useFPBalanceInfo = (accountType, base, quote, active = true) => {
    const assets = (0, exports.useCustomAssets)(accountType, active);
    return (0, react_1.useMemo)(() => {
        var _a, _b;
        const b = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(base);
        const q = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(quote);
        const p = assets === null || assets === void 0 ? void 0 : assets.positionMap.get(`${base}/${quote}`);
        let positionValue;
        let initMargin;
        if (p) {
            positionValue = new trade_utils_lib_1.SafeDecimal(0);
            initMargin = new trade_utils_lib_1.SafeDecimal(0);
            p.forEach((it) => {
                positionValue = positionValue.add(new trade_utils_lib_1.SafeDecimal(it.positionValue).abs());
                initMargin = initMargin.add(new trade_utils_lib_1.SafeDecimal(it.initialMargin).abs());
            });
        }
        return {
            baseBalance: b,
            quoteBalance: q,
            position: p,
            riskState: assets === null || assets === void 0 ? void 0 : assets.riskState,
            positionValue: (_a = positionValue === null || positionValue === void 0 ? void 0 : positionValue.toString()) !== null && _a !== void 0 ? _a : "",
            initMargin: (_b = initMargin === null || initMargin === void 0 ? void 0 : initMargin.toString()) !== null && _b !== void 0 ? _b : "",
        };
    }, [assets === null || assets === void 0 ? void 0 : assets.balanceMap, assets === null || assets === void 0 ? void 0 : assets.positionMap, assets === null || assets === void 0 ? void 0 : assets.riskState, base, quote]);
};
exports.useFPBalanceInfo = useFPBalanceInfo;
/** 注册单个币的持有信息 */
const useCustomBalance = (accountType, coin, active = true) => {
    const assets = (0, exports.useCustomAssets)(accountType, active);
    return (0, react_1.useMemo)(() => {
        const b = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(coin);
        const e = assets === null || assets === void 0 ? void 0 : assets.requestError;
        return {
            balance: b,
            error: e,
        };
    }, [assets === null || assets === void 0 ? void 0 : assets.balanceMap, assets === null || assets === void 0 ? void 0 : assets.requestError, coin]);
};
exports.useCustomBalance = useCustomBalance;
/**
 * 检测账户是否处于强平模式
 * @returns true 强平模式
 */
function isLiquidatingMode(state) {
    return [interface_1.TraderAccountRiskState.MERGING, interface_1.TraderAccountRiskState.LIQUIDATING, interface_1.TraderAccountRiskState.TAKEOVER].includes(state);
}
exports.isLiquidatingMode = isLiquidatingMode;
/**获取账户的风险等级以及是否强平
 * @returns riskState 风险等级
 * @returns isLiquidating 是否处于强平状态
 */
function useAccountRiskState(accountType, active = true) {
    const { riskState, quoteRiskMap, quoteRisks } = (0, exports.useCustomAssets)(accountType, active);
    return {
        riskState: riskState || interface_1.TraderAccountRiskState.TRADING,
        isLiquidating: isLiquidatingMode(riskState),
        quoteRiskMap,
        quoteRisks,
    };
}
exports.useAccountRiskState = useAccountRiskState;
/**获取某个币种的风险等级 */
function useCurrencyRiskState(accountType, currency, active = true) {
    const { quoteRiskMap } = useAccountRiskState(accountType, active);
    return quoteRiskMap === null || quoteRiskMap === void 0 ? void 0 : quoteRiskMap.get(currency);
}
exports.useCurrencyRiskState = useCurrencyRiskState;
/**通过传入的价格重新计算相关参数 */
function usePositionPnlByLatestPrice(position, basePrice, isActive) {
    return (0, react_1.useMemo)(() => {
        if (isActive && basePrice) {
            return processPositionWithPrice(position, basePrice);
        }
        // 直接返回原始数据
        return position;
    }, [isActive, basePrice, position]);
}
exports.usePositionPnlByLatestPrice = usePositionPnlByLatestPrice;
